// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "",
    "hash": "",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "",
    "semverString": null,
    "version": "0.0.0",
    "date": "2026-11-04T12:12:24.046Z"
};
/* tslint:enable */
